import {AxiosError} from 'axios';
import {POST_COORDINATOR_APPEAL_PROCEED_WITH_CANDIDATE_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ProceedWithCandidateResponse {
  uuid: string;
}

export interface ProceedWithCandidateRequest {
  indexNumber: string;
  nricFin: string;
  examCode: string;
  token: string | null;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: ProceedWithCandidateResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCoordinatorAppealProceedWithCandidate = ({
                                                               onSuccess,
                                                               onError,
                                                             }: Input = {}) => {
  const postCoordinatorAppealProceedWithCandidate = async (
      requestBody: ProceedWithCandidateRequest
  ) => {
    const res = await axiosClient.post<ProceedWithCandidateResponse>(
        POST_COORDINATOR_APPEAL_PROCEED_WITH_CANDIDATE_URL,
        requestBody
    );

    return res.data;
  };

  return useCustomMutation(postCoordinatorAppealProceedWithCandidate, {
    onSuccess,
    onError,
  });
};
